import { useSelectContext } from '../../select'
import type {
  SelectFieldContainerProps,
  SelectScopedProps,
} from '../../select.types'
import { selectFieldContainerVariants } from './index.styles'

export const SelectFieldContainer = ({
  __scopeInputSelect,
  children,
}: SelectScopedProps<SelectFieldContainerProps>) => {
  const { hasError, size, disabled, readOnly } = useSelectContext(
    'InputSelectHelperText',
    __scopeInputSelect
  )

  return (
    <div
      data-testid="select-field-container"
      className={selectFieldContainerVariants({
        hasError,
        size,
        disabled,
        readOnly,
      })}
    >
      {children}
    </div>
  )
}
